export const ADD_REQUEST = 'ADD_ASSESSMENT_QUESTION/ADD_REQUEST'
export const ADD_SUCCESS = 'ADD_ASSESSMENT_QUESTION/ADD_SUCCESS'
export const ADD_ERROR = 'ADD_ASSESSMENT_QUESTION/ADD_ERROR'

export const GET_REQUEST = 'ADD_ASSESSMENT_QUESTION/GET_REQUEST'
export const GET_SUCCESS = 'ADD_ASSESSMENT_QUESTION/GET_SUCCESS'
export const GET_ERROR = 'ADD_ASSESSMENT_QUESTION/GET_ERROR'

export const ADD_CLEAR = 'ADD_ASSESSMENT_QUESTION/ADD_CLEAR'

export const OWNER_REQUEST = 'ADD_ASSESSMENT_QUESTION/OWNER_REQUEST'
export const OWNER_SUCCESS = 'ADD_ASSESSMENT_QUESTION/OWNER_SUCCESS'
export const OWNER_ERROR = 'ADD_ASSESSMENT_QUESTION/OWNER_ERROR'
